import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SpinnerService } from 'src/app/shared/components/spinner/spinner.service';
import { LoginService } from '../../services/rest/login.service';
import { UtilsService } from '../../services/general-utils/utils.service';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'password-dimenticata-dialog',
  templateUrl: './password-dimenticata-dialog.component.html',
  styleUrls: ['./password-dimenticata-dialog.component.scss']
})
export class PasswordDimenticataDialogComponent implements OnInit, OnDestroy {

  displayModal: boolean;
  subscriptions: Subscription = new Subscription();

  formPassword: FormGroup;
  confirmSection: boolean;

  constructor(
    private spinner: SpinnerService,
    private loginService: LoginService,
    private utilsService: UtilsService,
    private translate: TranslateService
  ) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  openDialog() {
    this.formPassword = new FormGroup({
      username: new FormControl(null, Validators.required)
    });
    this.confirmSection = false;
    this.displayModal = true;
  }

  closeDialog() {
    this.formPassword = null;
    this.displayModal = false;
  }

  resetPassword() {
    this.spinner.activate();
    this.subscriptions.add(this.loginService.resetPassword(this.formPassword.get('username').value).subscribe({
      next: resp => {
        this.spinner.deactivate();
        Swal.fire({
          icon: 'success',
          title: this.translate.instant('resetEffettuato'),
          text: this.translate.instant('passwordoProvvisoriaInviata_msg') + resp,
          showConfirmButton: false,
          showCancelButton: false,
          timer: 4000
        }).then();
        this.closeDialog();
      },
      error: error => {
        this.spinner.deactivate();
        this.utilsService.fireErrorConfirmMsg('invioPasswordNonRiuscito', 'invioPasswordNonRiuscito_msg');
        this.closeDialog();
        throw error;
      }
    }));
  }

}